"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _reactCalendar = _interopRequireDefault(require("react-calendar"));
var _dateFns = require("date-fns");
var _utils = require("@trs/utils");
var _Datepicker = _interopRequireDefault(require("./Datepicker.style"));
var _Input = _interopRequireDefault(require("../../input/v2/Input"));
var _excluded = ["errors", "id", "placeholder", "value", "format", "position", "disabled", "minDate", "clearable"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This should be the datepicker component to be used in the application.
 * However, the old component is still used in the rules builder, so we
 * need to have this separate until the rules builder will use the new inputs
 */
var DatePicker = /*#__PURE__*/function (_React$PureComponent) {
  function DatePicker(props) {
    var _this;
    _classCallCheck(this, DatePicker);
    _this = _callSuper(this, DatePicker, [props]);
    _defineProperty(_this, "onChange", function (date) {
      _this.props.onChange(date);
      _this.setState({
        isOpen: false
      });
    });
    _defineProperty(_this, "handleFocus", function () {
      _this.setState({
        isOpen: true
      });
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_this, "handleClickOutside", function () {
      _this.setState({
        isOpen: false
      });
    });
    var isOpen = props.isOpen;
    _this.state = {
      isOpen: isOpen || false
    };
    return _this;
  }
  _inherits(DatePicker, _React$PureComponent);
  return _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        errors = _this$props.errors,
        id = _this$props.id,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        format = _this$props.format,
        position = _this$props.position,
        disabled = _this$props.disabled,
        minDate = _this$props.minDate,
        clearable = _this$props.clearable,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "datepicker-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_Datepicker["default"], _extends({}, otherProps, {
        id: id,
        position: position,
        hasError: !(0, _utils.isBlank)(errors),
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, otherProps, {
        inputProps: {
          readOnly: true
        },
        type: "text",
        isDisabled: disabled,
        placeholder: placeholder,
        icon: "ion-android-calendar",
        error: errors,
        id: "".concat(id, "Input"),
        onFocus: this.handleFocus,
        value: (0, _utils.processDate)(value, format)
      })), isOpen && /*#__PURE__*/_react["default"].createElement(_reactCalendar["default"], _extends({}, otherProps, {
        minDate: minDate instanceof Date ? new Date(minDate) : null,
        onChange: this.onChange,
        isOpen: isOpen,
        value: value instanceof Date ? value : new Date(),
        tileDisabled: function tileDisabled(_ref) {
          var date = _ref.date;
          return (0, _dateFns.isBefore)(date, minDate);
        }
      })), clearable && value ? /*#__PURE__*/_react["default"].createElement("span", {
        "aria-label": "Clear value",
        onClick: function onClick() {
          return !disabled && _this2.onChange('');
        },
        className: "datepicker-clear-zone",
        title: "Clear value",
        onKeyDown: function onKeyDown() {
          return !disabled && _this2.onChange('');
        },
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "datepicker-clear"
      }, "\xD7")) : ''));
    }
  }]);
}(_react["default"].PureComponent);
DatePicker.propTypes = {
  clearable: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,
  /** A list of erros associated to the input */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /** Html id */
  id: _propTypes["default"].string.isRequired,
  /** Date format */
  format: _propTypes["default"].string,
  /** Html id */
  disabled: _propTypes["default"].bool,
  /** The short hint displayed in the input before the user enters a value. */
  placeholder: _propTypes["default"].string,
  /** The position where to render the calendar (relative to the input) */
  position: _propTypes["default"].oneOf(['top', 'left', 'bottom', 'right']),
  /** The date value */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /* A min date */
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /** The date value */
  onChange: _propTypes["default"].func.isRequired
};
DatePicker.defaultProps = {
  clearable: false,
  value: null,
  isOpen: false,
  placeholder: 'dd/mm/yyyy',
  format: 'dd/MM/yyyy',
  minDate: null,
  position: 'bottom',
  errors: undefined,
  disabled: false
};
var _default = exports["default"] = (0, _reactClickOutside["default"])(DatePicker);